import { USER_ROLES } from '../constants/userRoles';

export const USERS_PAGE_SIZE = 10;

export const getCreatedAtMillis = (user) => {
  const value = user?.createdAt;

  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  if (value instanceof Date) return value.getTime();

  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const filterAndSortUsers = (users, view) => users
  .filter((item) => {
    const role = item.role || USER_ROLES.USER;
    return view === 'users'
      ? role === USER_ROLES.USER
      : role === USER_ROLES.AUTHOR || role === USER_ROLES.ADMIN;
  })
  .sort((a, b) => {
    const dateDifference = getCreatedAtMillis(b) - getCreatedAtMillis(a);
    if (dateDifference !== 0) return dateDifference;

    return String(a.username || a.email || '').localeCompare(
      String(b.username || b.email || ''),
      'uk'
    );
  });

export const getTotalPages = (totalItems, pageSize = USERS_PAGE_SIZE) =>
  Math.max(1, Math.ceil(totalItems / pageSize));

export const getValidPage = (
  currentPage,
  totalItems,
  pageSize = USERS_PAGE_SIZE
) => Math.min(Math.max(1, currentPage), getTotalPages(totalItems, pageSize));

export const paginateUsers = (
  users,
  currentPage,
  pageSize = USERS_PAGE_SIZE
) => {
  const page = getValidPage(currentPage, users.length, pageSize);
  const startIndex = (page - 1) * pageSize;

  return {
    items: users.slice(startIndex, startIndex + pageSize),
    page,
    totalPages: getTotalPages(users.length, pageSize),
    start: users.length === 0 ? 0 : startIndex + 1,
    end: Math.min(startIndex + pageSize, users.length),
    totalItems: users.length,
  };
};
